import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaUser, FaLock } from 'react-icons/fa';

const Login: React.FC = () => {
  const [email, setEmail] = useState('admin@demo.com');
  const [password, setPassword] = useState('password');
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);
  
  const { login, token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate('/dashboard', { replace: true });
      return;
    }
    if (localStorage.getItem('sessionExpired')) {
      setSessionExpired(true);
      localStorage.removeItem('sessionExpired');
    }
  }, [token, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Error al iniciar sesión');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light" style={{ padding: '1rem' }}>
      <div className="card shadow-sm" style={{ maxWidth: '400px', width: '100%' }}>
        <div className="card-body p-3 p-md-4">
          <div className="text-center mb-3">
            <img 
              src="/logo512.png" 
              alt="Alfitell" 
              style={{ 
                width: '120px', 
                height: '120px', 
                objectFit: 'contain',
                maxWidth: '100%'
              }} 
              className="img-fluid"
            />
          </div>
          <h3 className="card-title text-center mb-3 mb-md-4" style={{ fontSize: '1.25rem' }}>
            Sistema de Control <small className="text-muted d-block d-md-inline" style={{ fontSize: '0.85rem' }}>v{process.env.REACT_APP_VERSION || '1.0.0'}</small>
          </h3>
          
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          {sessionExpired && (
            <div className="alert alert-warning" role="alert">
              Tu sesión ha expirado. Por favor, inicia sesión nuevamente.
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label small">
                <FaUser className="me-2" />
                Correo Electrónico
              </label>
              <input
                type="email"
                className="form-control form-control-lg"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                disabled={isLoading}
                placeholder="usuario@ejemplo.com"
              />
            </div>

            <div className="mb-4">
              <label htmlFor="password" className="form-label small">
                <FaLock className="me-2" />
                Contraseña
              </label>
              <input
                type="password"
                className="form-control form-control-lg"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                disabled={isLoading}
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              className="btn btn-lg w-100"
              style={{ backgroundColor: '#fe5f0b', borderColor: '#fe5f0b', color: 'white', fontWeight: 500 }}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Iniciando sesión...
                </>
              ) : (
                'Iniciar Sesión'
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;

